import { Box, Typography } from "@mui/material";

export default function Copyright(): JSX.Element {
  return (
    <Box
      sx={{
        padding: "10px 20px",
      }}
    >
      <Typography variant={"caption"}>
        Copyright 2024 123Skincare | Pizia Limited
      </Typography>
    </Box>
  )
}